import { render } from "./validateIdCard.vue?vue&type=template&id=71d362fc&scoped=true"
import script from "./validateIdCard.vue?vue&type=script&lang=js"
export * from "./validateIdCard.vue?vue&type=script&lang=js"

import "./validateIdCard.vue?vue&type=style&index=0&id=71d362fc&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d362fc"]])

export default __exports__